<template>
  <div id="LaborManangementReport">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area" >
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title">Labor Management Report</div>
          <div class="web-action-btn btn-groups text-right">
              <!-- Button for Clear Cache
              <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data> -->
              <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                  <i class="fp-export"></i> Export
              </a>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content contact-list">
            <data-table-filter-config :moduleName="'laborManagementReport'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
              <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
              <section class="bg-white data-table">
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange" :moduleName="'laborManagementReport'" :position="'top'">
                </custom-pagination>
                <vue-good-table
                  mode="remote"
                  title="Labor Management Report"
                  ref="laborManagementReport"
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                  @on-select-all="onSelectAll"
                  @on-selected-rows-change="selectionChanged"
                  :totalRows="totalRecords"
                  :columns="userColumns"
                  :rows="rows"
                  :paginationOptions="{
                      enabled: false,
                      position: 'both',
                      perPage: perPage,
                      dropdownAllowAll: false,
                      setCurrentPage:listCurrentPage,
                      perPageDropdown:dropDownPerPage,
                  }"
                  :select-options="{
                      enabled: false,
                      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                      selectionInfoClass: 'custom-class',
                      selectionText: 'rows selected',
                      clearSelectionText: 'clear',
                  }"
                  :search-options="{
                  enabled: false,
                  }"

                  >
                </vue-good-table>
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange">
                </custom-pagination>
              </section>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
              <h1>
                  Oops!</h1>
              <h2>
                  403 </h2>
              <div class="error-details">
                  Sorry!, You don't have permission to access this page.
              </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
 import {commonMixins} from '../../mixins/commonMixins';
 import {dataTableMixins} from '../../mixins/dataTableMixins';
export default {
  name: "GangsheetReport",
  metaInfo() {
            return {title: "Labor Management Report | " +process.env.COPYRIGHT_NAME}
        },
  mixins: [commonMixins,dataTableMixins],
  data: () => ({
    cantAccessPage:"",
    loading: false,
    action: '',
    permissions:[],
    rows: [],
    totalRecords: 0,
    userColumns:[],
    columns: [
            {
                label: 'Facility Code',
                field: 'location',
                filterable: true,
                fpFieldType:"option",
                hidden:false,
            },
            {
                label: 'Facility Description',
                field: 'location_desc',
                filterable: false,
                fpFieldType:"text",
                hidden:false,
            },
            {
                label: 'Region Code',
                field: 'region_code',
                filterable: false,
                fpFieldType:"text",
                hidden:false,
                sortable : false
            },
            {
                label: 'Region Description',
                field: 'region_desc',
                filterable: false,
                fpFieldType:"text",
                hidden:false,
                sortable : false,
            },
            {
                label: 'Employee Number',
                field: 'employee_number',
                filterable: false,
                fpFieldType:"text",
                hidden:false,
            },
            {
                label: 'Employee Last Name',
                field: 'last_name',
                filterable: false,
                fpFieldType:"text",
                hidden:false,
            },
            {
                label: 'Employee First Name',
                field: 'first_name',
                filterable: false,
                fpFieldType:"text",
                hidden:false,
            },
            {
                label: 'Maintenance Non-Billable',
                field: 'non_billable_hour',
                filterable: false,
                fpFieldType:"integer",
                hidden:false,
            },
            {
                label: '% Total Maint Non-Billable',
                field: 'total_non_billable_per',
                filterable: false,
                fpFieldType:"integer",
                hidden:false,
                sortable:false
            },
            {
                label: 'Maintenance Billable',
                field: 'billable_hour',
                filterable: false,
                fpFieldType:"integer",
                hidden:false,
            },
            {
                label: '% Total Maint Billable',
                field: 'total_billable_per',
                filterable: false,
                fpFieldType:"integer",
                hidden:false,
                sortable:false
            },
            {
                label: 'Total Maintenance',
                field: 'total_billable_hour',
                filterable: false,
                fpFieldType:"integer",
                hidden:false,
            },
            {
                label: '% Total - Total Maintenance',
                field: 'total_maintenance_per',
                filterable: false,
                fpFieldType:"integer",
                hidden:false,
                sortable:false
            },
            {
                label: 'Idle Time',
                field: 'idle_time',
                filterable: false,
                fpFieldType:"integer",
                hidden:false,
            },
            {
                label: '% Total Idle',
                field: 'idle_time_per',
                filterable: false,
                fpFieldType:"integer",
                hidden:false,
                sortable:false
            },
            {
                label: 'Other UnPaid Indirect',
                field: 'unpaid_indirect',
                filterable: false,
                fpFieldType:"integer",
                hidden:false,
                sortable:false
            },
            {
                label: '% Total Other UnPaid Indirect',
                field: 'total_unpaid_indirect_per',
                filterable: false,
                fpFieldType:"integer",
                hidden:false,
                sortable:false
            },
            {
                label: 'Indirect',
                field: 'indirect',
                filterable: false,
                fpFieldType:"integer",
                hidden:false,
            },
            {
                label: '% Total Indirect',
                field: 'total_indirect_per',
                filterable: false,
                fpFieldType:"integer",
                hidden:false,
                sortable:false
            },
            {
                label: 'Total',
                field: 'total',
                filterable: false,
                fpFieldType:"integer",
                hidden:false,
                sortable:false
            },
            {
                label: 'Indirect Amt 1',
                field: 'indirect_amt_1',
                filterable: false,
                fpFieldType:"integer",
                hidden:false,
                sortable:false
            },
            {
                label: '% Total Indirect 1',
                field: 'total_indirect_1',
                filterable: false,
                fpFieldType:"integer",
                hidden:false,
                sortable:false
            },
            {
                label: 'Indirect Amt 2',
                field: 'indirect_amt_2',
                filterable: false,
                fpFieldType:"integer",
                hidden:false,
                sortable:false
            },
            {
                label: '% Total Indirect 2',
                field: 'total_indirect_2',
                filterable: false,
                fpFieldType:"integer",
                hidden:false,
                sortable:false
            },
            {
                label: 'Indirect Amt 3',
                field: 'indirect_amt_3',
                filterable: false,
                fpFieldType:"integer",
                hidden:false,
                sortable:false
            },
            {
                label: '% Total Indirect 3',
                field: 'total_indirect_3',
                filterable: false,
                fpFieldType:"integer",
                hidden:false,
                sortable:false
            },
            {
                label: 'Indirect Amt 4',
                field: 'indirect_amt_4',
                filterable: false,
                fpFieldType:"integer",
                hidden:false,
                sortable:false
            },
            {
                label: '% Total Indirect 4',
                field: 'total_indirect_4',
                filterable: false,
                fpFieldType:"integer",
                hidden:false,
                sortable:false
            },
            {
                label: 'Indirect Amt 5',
                field: 'indirect_amt_5',
                filterable: false,
                fpFieldType:"integer",
                hidden:false,
                sortable:false
            },
            {
                label: '% Total Indirect 5',
                field: 'total_indirect_5',
                filterable: false,
                fpFieldType:"integer",
                hidden:false,
                sortable:false
            },
            {
                label: 'Indirect Amt 6',
                field: 'indirect_amt_6',
                filterable: false,
                fpFieldType:"integer",
                hidden:false,
                sortable:false
            },
            {
                label: '% Total Indirect 6',
                field: 'total_indirect_6',
                filterable: false,
                fpFieldType:"integer",
                hidden:false,
                sortable:false
            },
            {
                label: 'Indirect Amt 7',
                field: 'indirect_amt_7',
                filterable: false,
                fpFieldType:"integer",
                hidden:false,
                sortable:false
            },
            {
                label: '% Total Indirect 7',
                field: 'total_indirect_7',
                filterable: false,
                fpFieldType:"integer",
                hidden:false,
                sortable:false
            },
            {
                label: 'Indirect Amt 8',
                field: 'indirect_amt_8',
                filterable: false,
                fpFieldType:"integer",
                hidden:false,
                sortable:false
            },
            {
                label: '% Total Indirect 8',
                field: 'total_indirect_8',
                filterable: false,
                fpFieldType:"integer",
                hidden:false,
                sortable:false
            },
            {
                label: 'Indirect Amt 9',
                field: 'indirect_amt_9',
                filterable: false,
                fpFieldType:"integer",
                hidden:false,
                sortable:false
            },
            {
                label: '% Total Indirect 9',
                field: 'total_indirect_9',
                filterable: false,
                fpFieldType:"integer",
                hidden:false,
                sortable:false
            },
            {
                label: 'Other Paid',
                field: 'paid_indirect',
                filterable: false,
                fpFieldType:"integer",
                hidden:false,
                sortable:false
            },
            {
                label: '% Total Other Paid',
                field: 'total_other_paid_per',
                filterable: false,
                fpFieldType:"integer",
                hidden:false,
                sortable:false
            },
            {
                label: 'Labor Report Detail Level',
                field: 'detail_value',
                filterable: false,
                fpFieldType:"option",
                hidden:true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Updated Duration", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: ['Facility','Employee'],
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'From Date',
                field: 'start_date',
                filterable: false,
                fpFieldType:"text",
                hidden:true,
            },
            {
                label: 'To Date',
                field: 'end_date',
                filterable: false,
                fpFieldType:"text",
                hidden:true,
            },
        ],
    batchProcess:0,
    batchNum:"",
  }),
  watch:{
    permissions: function(permission) {
        var self = this;
        permission.forEach(function (permissions) {
            if(permissions.name == 'labor_management_report') {
                self.cantAccessPage = true;
            }
        });
        if(self.cantAccessPage == ''){
            self.cantAccessPage = false;
        }
    },
  },
  mounted: function(){
    var self = this;
    self.getPermissions();
  },
  methods:{
    cancelAll: function (cancelAll) {
      this.$refs.gangsheetReport.unselectAllInternal();
    },
    // exportReports: function() {
    //     var self = this;
    //     this.action = "export";
    //     this.loadList();
    // },
    loadList: function(){

      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();

      var selectedRows = [];
      var data = this.$refs['laborManagementReport'].selectedRows;
      for ( var i = 0; i < data.length; i++ ) {
          selectedRows.push(this.$refs['laborManagementReport'].selectedRows[i].id)
      }

      $.ajax({
        url: process.env.ROOT_API + "/labor-management-report/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: this.serverParams.columnFilters,
          sort: this.serverParams.sort,
          offset: offset,
          action: self.action,
          selectedAll:self.serverParams.selectedAll,
          selectedRows:selectedRows,
        },
        success: function(data) {
          self.loading = false;
          //console.log(data.content[0]["id"]);
          if (data.status == "success") {

            if (self.action == "export" ||  self.action == "export_queue") {

                if ( data.code == "201" ) {
                    alert(data.message);
                } else {

                    if ( self.action == "export" ) {

                        self.excel = data.content.web;
                        var save = document.createElement("a");
                        save.href = self.excel;
                        save.download = data.content.web;
                        save.target = "_blank";

                        document.body.appendChild(save);
                        save.click();
                        document.body.removeChild(save);

                    } else {

                        self.batchProcess = 1;
                        self.batchNum = data.content;
                    }

                }

              self.action = "list";
              self.loadList();
            } else {
              if (data.content.row != undefined) {
                self.rows = data.content.row;
              }
              self.totalRecords = data.content.totalRecords;
            }
          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'gangsheet-report');
        }
      });


    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/LaborManagementReport.vue